module.exports = __webpack_public_path__ + "static/media/RightPartner3.d0af00ee.jpg";